export default __webpack_public_path__ + "static/media/idan-erlichman.61bb8910.png";